import React from 'react';

export function AgricultureIcon() {
  return (
    <svg viewBox="0 0 80 80" fill="none">
      <circle cx="40" cy="40" r="35" stroke="#52B788" strokeWidth="1" opacity=".3" />
      <path d="M40 60 L40 25" stroke="#52B788" strokeWidth="2" />
      <path d="M40 25 Q30 20 28 10" stroke="#52B788" strokeWidth="1.5" fill="none" />
      <path d="M40 30 Q50 25 52 15" stroke="#52B788" strokeWidth="1.5" fill="none" />
      <path d="M40 35 Q30 30 25 22" stroke="#52B788" strokeWidth="1.5" fill="none" />
      <path d="M40 40 Q50 35 55 28" stroke="#52B788" strokeWidth="1.5" fill="none" />
      <ellipse cx="28" cy="10" rx="5" ry="8" fill="#52B788" opacity=".3" transform="rotate(-20 28 10)" />
      <ellipse cx="52" cy="15" rx="5" ry="8" fill="#52B788" opacity=".3" transform="rotate(20 52 15)" />
      <circle cx="60" cy="15" r="8" fill="#C4923A" opacity=".4" />
      <path d="M15 60 Q27 56 40 60 Q53 56 65 60" stroke="#52B788" strokeWidth="1" opacity=".4" />
    </svg>
  );
}

export function IncomeIcon() {
  return (
    <svg viewBox="0 0 80 80" fill="none">
      <circle cx="40" cy="40" r="35" stroke="#C4923A" strokeWidth="1" opacity=".3" />
      <circle cx="28" cy="28" r="6" stroke="#C4923A" strokeWidth="1.5" fill="none" />
      <path d="M18 50 Q18 40 28 38 Q38 40 38 50" stroke="#C4923A" strokeWidth="1.5" fill="none" />
      <circle cx="52" cy="28" r="6" stroke="#C4923A" strokeWidth="1.5" fill="none" />
      <path d="M42 50 Q42 40 52 38 Q62 40 62 50" stroke="#C4923A" strokeWidth="1.5" fill="none" />
      <path d="M40 65 L40 55 L50 55" stroke="#52B788" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      <polygon points="50,52 56,55 50,58" fill="#52B788" opacity=".6" />
    </svg>
  );
}

export function PlanetIcon() {
  return (
    <svg viewBox="0 0 80 80" fill="none">
      <circle cx="40" cy="38" r="24" stroke="#52B788" strokeWidth="1.5" fill="none" />
      <ellipse cx="40" cy="38" rx="12" ry="24" stroke="#52B788" strokeWidth=".8" fill="none" opacity=".4" />
      <path d="M16 38 L64 38" stroke="#52B788" strokeWidth=".8" opacity=".4" />
      <path d="M30 28 Q35 25 38 30 Q42 28 45 32 Q40 35 35 33Z" fill="#52B788" opacity=".3" />
      <path d="M35 65 Q40 72 45 65 Q48 60 45 57 Q42 54 40 58 Q38 54 35 57 Q32 60 35 65Z" fill="#E5243B" opacity=".5" />
    </svg>
  );
}

export function LandscapeIcon() {
  return (
    <svg viewBox="0 0 80 80" fill="none">
      <rect x="18" y="35" width="12" height="30" rx="1" stroke="#52B788" strokeWidth="1.2" fill="none" opacity=".5" />
      <rect x="34" y="25" width="12" height="40" rx="1" stroke="#52B788" strokeWidth="1.2" fill="none" opacity=".5" />
      <rect x="50" y="30" width="12" height="35" rx="1" stroke="#52B788" strokeWidth="1.2" fill="none" opacity=".5" />
      <rect x="21" y="40" width="3" height="3" fill="#52B788" opacity=".3" />
      <rect x="37" y="30" width="3" height="3" fill="#52B788" opacity=".3" />
      <rect x="53" y="35" width="3" height="3" fill="#52B788" opacity=".3" />
      <line x1="40" y1="65" x2="40" y2="72" stroke="#52B788" strokeWidth="1.5" />
      <circle cx="40" cy="62" r="5" fill="#52B788" opacity=".4" />
      <path d="M10 65 Q20 62 30 65 Q40 62 50 65 Q60 62 70 65" stroke="#52B788" strokeWidth="1" fill="none" opacity=".4" />
    </svg>
  );
}

const iconMap = {
  agriculture: AgricultureIcon,
  income: IncomeIcon,
  planet: PlanetIcon,
  landscape: LandscapeIcon,
};

export default iconMap;
